import FullScreenLoader from "../../../BON Frontend/Booking-Form/Common/FullScreenLoader";
// import { useEffect, useState } from "react";
// import Hearder from "../../commun/Hearder";
// import SideBar from "../../commun/SideBar";
// import Select from "react-select";
// import swal from "sweetalert";
// import { PropertyMAppingList, PropertyMealplan, PropertyRateCode, roomlistdetail, PropertySaveMapping, PropertyMappingDelete, getBasicPropertydetails } from "../../../Services/Service";
// import { NavLink } from "react-router-dom";
// import { DataTable } from "primereact/datatable";
// import { Column } from "primereact/column";
// import { Button } from "primereact/button";

// export const RateInventory = () => {
//     const [loading, setLoading] = useState(false);
//     const [mappinglist, setMappingList] = useState([]);
//     const [ratecode, setRatecode] = useState([]);
//     const [mealplan, setMealplan] = useState([]);
//     const [rooms, setRooms] = useState([]);
//     const [selectedRate, setSelectedRate] = useState("");
//     const [selectedMealPlan, setSelectedMealPlan] = useState("");
//     const [selectedRoom, setSelectedRoom] = useState("");

//     const [baseRate, setBaseRate] = useState(0);
//     const [doubleRate, setDoubleRate] = useState(0);
//     const [tripleRate, setTripleRate] = useState(0);
//     const [extraBed, setExtraBed] = useState(0);
//     const [extraAdultRate, setExtraAdultRate] = useState(0);
//     const [extraChildRate, setExtraChildRate] = useState(0);
//     const [effectiveFrom, setEffectiveFrom] = useState("");
//     const [effectiveTo, setEffectiveTo] = useState("");
//     const [isActive, setIsActive] = useState(true);
//     const [editId, setEditId] = useState(0);
//     const [Pms, setPMS] = useState();

//     const [filteredList, setFilteredList] = useState([]);
//     const [selectedRooms, setSelectedRooms] = useState([]);

//     // NEW: tracks whether the user has applied a filter yet.
//     // Table stays empty (with a custom message) until this becomes true.
//     const [isFiltered, setIsFiltered] = useState(false);

//     // rate code Mappig List
//     const fetchMappingList = async (rateCodeId) => {
//         setLoading(true);
//         try {
//             const result = await PropertyMAppingList(rateCodeId);
//             if (Array.isArray(result)) setMappingList(result);
//             else setMappingList([]);
//         } catch (error) {
//             console.log("Error fetching mapping list", error);
//             setMappingList([]);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Property Rate Code 
// useEffect(() => {
//     const FetchRatecode = async () => {

//         try {
//             const result = await PropertyRateCode();
//             if (Array.isArray(result)) {
//                 setRatecode(result);

//                 const firstRateCodeId = result.length > 0 ? result[0].RateCodeID : 0;

//                 // Now call mapping list API with that rate code id
//                 fetchMappingList(firstRateCodeId);
//             } else {
//                 // if not array, call mapping list with 0
//                 fetchMappingList(0);
//             }
//         }
//         catch (error) {
//             console.log("error get rate code", error);
//             fetchMappingList(0);
//         }
//     }
//     FetchRatecode();
// }, []);


//     // meal paln detail
//     useEffect(() => {
//         const FetchMealplan = async () => {

//             try {
//                 const result = await PropertyMealplan();
//                 if (Array.isArray(result)) setMealplan(result);
//             }
//             catch (error) {
//                 console.log("error get meal plan", error);
//             } 
//         }
//         FetchMealplan();
//     }, []);

//     // room detail 
//     useEffect(() => {
//         const fetchRoomData = async () => {

//             try {
//                 const data = await roomlistdetail();
//                 if (Array.isArray(data)) setRooms(data);

//             } catch (error) {
//                 console.error("Room data fetch error:", error);
//             } 
//         };
//         fetchRoomData();
//     }, []);

//     // Open modal for edit
//     const handleEdit = (item) => {
//         setEditId(item.RateCodeMealPlanID);
//         setSelectedRate(item.RateCodeID);
//         setSelectedMealPlan(item.MealPlanID);
//         setSelectedRoom(item.RoomTypeID);
//         setBaseRate(item.BaseRate);
//         setDoubleRate(item.DoubleRate);
//         setTripleRate(item.TripleRate);
//         setExtraBed(item.ExtraBed);
//         setExtraAdultRate(item.ExtraAdultRate);
//         setExtraChildRate(item.ExtraChildRate);
//         setEffectiveFrom(item.EffectiveFrom.split("T")[0]);
//         setEffectiveTo(item.EffectiveTo.split("T")[0]);
//         setIsActive(item.IsActive === 1);
//     };

//     // Submit handler
//     const handleSubmit = async () => {
//         if (!selectedMealPlan || !selectedRoom) {
//             swal("Error", "Please select Rate, Meal Plan and Room", "error");
//             return;
//         }
//         try {
//             setLoading(true);

//             await PropertySaveMapping(
//                 editId,
//                 selectedRate || 0,
//                 selectedMealPlan,
//                 selectedRoom,
//                 baseRate,
//                 doubleRate,
//                 tripleRate,
//                 extraBed,
//                 extraAdultRate,
//                 extraChildRate,
//                 effectiveFrom,
//                 effectiveTo,
//                 isActive ? 1 : 0
//             );

//             // refresh table
//             const result = await PropertyMAppingList(5);
//             if (Array.isArray(result)) setMappingList(result);

//             // show success alert
//             swal("Data Saved successfully", {
//                 icon: "success",
//                 buttons: {
//                     confirm: {
//                         text: "OK",
//                         className: "btn btn-success",
//                     },
//                 },
//             }).then(() => {
//                 // close modal
//                 const modal = window.bootstrap.Modal.getInstance(
//                     document.getElementById("example-modal-lg")
//                 );
//                 if (modal) modal.hide();

//                 // reset form fields
//                 setSelectedRate("");
//                 setSelectedMealPlan("");
//                 setSelectedRoom("");
//                 setBaseRate("");
//                 setDoubleRate("");
//                 setTripleRate("");
//                 setExtraBed("");
//                 setExtraAdultRate("");
//                 setExtraChildRate("");
//                 setEffectiveFrom("");
//                 setEffectiveTo("");
//                 setIsActive(true);
//                 setEditId(0);
//             });

//         } catch (error) {
//             console.log("Error saving mapping", error);
//             swal("Failed to save data!", { icon: "error" });
//         } finally {
//             setLoading(false);
//         }
//     };


//     const handleDelete = async (RateCodeMealPlanID) => {
//         setLoading(true);
//         try {
//             const confirm = await swal({
//                 title: "Are you sure?",
//                 icon: "warning",
//                 buttons: {
//                     cancel: "Cancel",
//                     confirm: {
//                         text: "Delete",
//                         value: true,
//                         visible: true,
//                         className: "btn-danger",
//                         closeModal: true,
//                     },
//                 },
//                 dangerMode: true,
//             });

//             if (confirm) {
//                 await PropertyMappingDelete(RateCodeMealPlanID);

//                 // state update without refetch
//                 setMappingList((prev) =>
//                     prev.filter((item) => item.RateCodeMealPlanID !== RateCodeMealPlanID)
//                 );
//                 setFilteredList((prev) =>
//                     prev.filter((item) => item.RateCodeMealPlanID !== RateCodeMealPlanID)
//                 );

//                 swal("Mapping deleted successfully!", {
//                     icon: "success",
//                 });
//             }
//         } catch (error) {
//             console.log("error deleting mapping", error);
//             swal("Failed to delete mapping!", { icon: "error" });
//         } finally {
//             setLoading(false);
//         }
//     };


//     const formatOptions = (list, labelKey, valueKey) => {
//         return list.map((item) => ({
//             label: item[labelKey],
//             value: item[valueKey],
//         }));
//     };

//     // NOTE: purposely NOT syncing filteredList with mappinglist automatically.
//     // Table should stay empty until the user clicks "Filter".

//     // Filter handler
//     const handleFilter = (e) => {
//         e.preventDefault();
//         setLoading(true);

//         let temp = mappinglist;

//         if (selectedRate) {
//             temp = temp.filter((item) => item.RateCodeID === Number(selectedRate));
//         }
//         if (selectedRoom) {
//             temp = temp.filter((item) => item.RoomTypeID === Number(selectedRoom));
//         }
//         if (selectedMealPlan) {
//             temp = temp.filter((item) => item.MealPlanID === Number(selectedMealPlan));
//         }


//         // from & to date filter
//         if (effectiveFrom) {
//             temp = temp.filter((item) => item.EffectiveFrom.split("T")[0] >= effectiveFrom);
//         }
//         if (effectiveTo) {
//             temp = temp.filter((item) => item.EffectiveTo.split("T")[0] <= effectiveTo);
//         }

//         setFilteredList(temp);
//         setIsFiltered(true); // filter applied, now table is allowed to show data

//         setLoading(false);
//     };

//     // Clear handler
//     const handleClear = () => {
//         setSelectedRate("");
//         setSelectedRoom("");
//         setSelectedMealPlan("");
//         setEffectiveFrom("");
//         setEffectiveTo("");
//         setFilteredList([]);
//         setIsFiltered(false); // back to "No rate code List Found" state
//     };

//     useEffect(() => {
//         const FetchPMS = async () => {
//             try {
//                 const result = await getBasicPropertydetails();
//                 if (result && result.length > 0) {
//                     setPMS(result[0]);
//                 }
//             }
//             catch (error) {
//                 console.log("error fetch Pms in get api", error);
//             }
//         }
//         FetchPMS();
//     }, [])

//     return (

//         <>
//             <style>{`
//            .form-control{
//             border-width: 1px !important;
//             border-color: hsl(0, 0%, 80%);
//            }   
//         `}</style>
//             {loading && (
//                 <div className="fullscreen-loader">
//                     <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
//                 </div>
//             )}
//             <div className="wrapper">
//                 <SideBar />
//                 <div className="main-panel">
//                     <Hearder />
//                     <div className="container">
//                         <div className="page-inner">
//                             <div className="row">
//                                 <div className="col-md-12">

//                                     <div className="card">
//                                         <div className="card-body">
//                                             <form className="mb-0" onSubmit={handleFilter}>
//                                                 <div className="row">
//                                                     {Pms?.PMS === "Opera" && (
//                                                         <div className="col-sm-2">
//                                                             <div className="mb-3">
//                                                                 <label className="form-label"> Rate Code</label>

//                                                                 <Select
//                                                                     options={formatOptions(ratecode, "Name", "RateCodeID")}
//                                                                     value={
//                                                                         selectedRate
//                                                                             ? {
//                                                                                 label:
//                                                                                     ratecode.find((r) => r.RateCodeID === selectedRate)?.Name ||
//                                                                                     "",
//                                                                                 value: selectedRate,
//                                                                             }
//                                                                             : null
//                                                                     }
//                                                                     onChange={(e) => setSelectedRate(e ? e.value : "")}
//                                                                     placeholder="Select code"
//                                                                     isClearable

//                                                                 />
//                                                             </div>
//                                                         </div>
//                                                     )}
//                                                     <div className="col-sm-2">
//                                                         <div className="mb-3">
//                                                             <label className="form-label"> Room Name</label>

//                                                             <Select
//                                                                 options={formatOptions(rooms, "RoomName", "RoomID")}
//                                                                 value={
//                                                                     selectedRoom
//                                                                         ? {
//                                                                             label:
//                                                                                 rooms.find((r) => r.RoomID === selectedRoom)?.RoomName ||
//                                                                                 "",
//                                                                             value: selectedRoom,
//                                                                         }
//                                                                         : null
//                                                                 }
//                                                                 onChange={(e) => setSelectedRoom(e ? e.value : "")}
//                                                                 placeholder="Select room"
//                                                                 isClearable
//                                                             />
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-sm-2">
//                                                         <div className="mb-3">
//                                                             <label className="form-label"> Meal Plan</label>

//                                                             <Select
//                                                                 options={formatOptions(mealplan, "Name", "MealPlanID")}
//                                                                 value={
//                                                                     selectedMealPlan
//                                                                         ? {
//                                                                             label:
//                                                                                 mealplan.find((m) => m.MealPlanID === selectedMealPlan)
//                                                                                     ?.Name || "",
//                                                                             value: selectedMealPlan,
//                                                                         }
//                                                                         : null
//                                                                 }
//                                                                 onChange={(e) => setSelectedMealPlan(e ? e.value : "")}
//                                                                 placeholder="Select plan"
//                                                                 isClearable
//                                                             />
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-sm-2">
//                                                         <div className="mb-3">
//                                                             <label className="form-label"> From</label>
//                                                             <input type="date" className="form-control" value={effectiveFrom}
//                                                                 onChange={(e) => setEffectiveFrom(e.target.value)} />
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-sm-2">
//                                                         <div className="mb-3">
//                                                             <label className="form-label"> To</label>
//                                                             <input type="date" className="form-control" value={effectiveTo}
//                                                                 onChange={(e) => setEffectiveTo(e.target.value)}
//                                                             />
//                                                         </div>
//                                                     </div>
//                                                     <div className="col-sm-2">
//                                                         <div style={{ marginTop: "27px" }}>
//                                                             <Button type="submit" label="Filter" size="small" className="btn btn-primary me-2" />
//                                                             <Button type="button" label="Clear" size="small" severity="danger" onClick={handleClear} className="btn btn-danger"/>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </form>
//                                         </div>
//                                     </div>

//                                 </div>
//                             </div>
//                             <div className="row">
//                                 <div className="col-md-12">

//                                     <div className="card">
//                                         <div className="card-header">
//                                             <div className="d-flex justify-content-between align-items-center">
//                                                 <h4 className="card-title mb-0">Rate Inventory List</h4>
//                                                 <NavLink to="/Property/AddRateInventory" className="btn btn-sm btn-primary">Add</NavLink>
//                                             </div>
//                                         </div>
//                                         <div className="card-body p-0">
//                                             <div className="table-responsive">

//                                                 <DataTable
//                                                     value={isFiltered ? filteredList : []}
//                                                     dataKey="RateCodeMealPlanID"
//                                                     paginator
//                                                     rows={10}
//                                                     rowsPerPageOptions={[5, 10, 25, 50]}
//                                                     currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
//                                                     paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
//                                                     stripedRows
//                                                     removableSort
//                                                     responsiveLayout="scroll"
//                                                     emptyMessage={isFiltered ? "No records found" : "No rate code List Found"}
//                                                 >
//                                                     {Pms?.PMS === "Opera" && (
//                                                         <Column field="RateCodeName" header="Rate Code" sortable />
//                                                     )}
//                                                     <Column field="RoomName" header="Room Name" sortable style={{ minWidth: "220px" }} />
//                                                     <Column field="MealPlanName" header="Meal Plan" sortable />
//                                                     <Column field="BaseRate" header="Base Rate" sortable body={(row) => `₹ ${row.BaseRate ?? 0}`} />
//                                                     <Column field="EffectiveFrom" header="From" sortable body={(row) => row.EffectiveFrom ? new Date(row.EffectiveFrom).toLocaleDateString("en-GB") : "-"} />
//                                                     <Column field="EffectiveTo" header="To" sortable body={(row) => row.EffectiveTo ? new Date(row.EffectiveTo).toLocaleDateString("en-GB") : "-"} />
//                                                     <Column
//                                                         field="IsActive"
//                                                         header="Status"
//                                                         body={(row) => (
//                                                             <span className={`badge ${row.IsActive ? "bg-success" : "bg-danger"}`}>
//                                                                 {row.IsActive ? "Active" : "Inactive"}
//                                                             </span>
//                                                         )}
//                                                     />
//                                                     <Column
//                                                         header="Action"
//                                                         body={(row) => (
//                                                             <div className="d-flex align-items-center gap-2">
//                                                                 <Button
//                                                                     type="button"
//                                                                     icon="pi pi-pencil"
//                                                                     text
//                                                                     size="small"
//                                                                     data-bs-toggle="modal"
//                                                                     data-bs-target="#example-modal-lg"
//                                                                     aria-label={`Edit ${row.RoomName}`}
//                                                                     onClick={() => handleEdit(row)}
//                                                                 />
//                                                                 <Button
//                                                                     type="button"
//                                                                     icon="pi pi-trash"
//                                                                     text
//                                                                     severity="danger"
//                                                                     size="small"
//                                                                     aria-label={`Delete ${row.RoomName}`}
//                                                                     onClick={() => handleDelete(row.RateCodeMealPlanID)}
//                                                                 />
//                                                             </div>
//                                                         )}
//                                                     />
//                                                 </DataTable>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>


//                     <>
//                         {/*  Modal */}
//                         <div
//                             className="modal fade"
//                             id="example-modal-lg"
//                             tabIndex={-1}
//                             role="dialog"
//                             aria-labelledby="myLargeModalLabel"
//                             aria-hidden="true"
//                         >
//                             <div className="modal-dialog modal-lg">
//                                 <div className="modal-content">
//                                     <div className="modal-header">
//                                         <h5 className="modal-title" id="myLargeModalLabel">
//                                             {editId === 0 ? "Add Rates" : "Edit Rates"}
//                                         </h5>
//                                         <button
//                                             type="button"
//                                             className="btn-close"
//                                             data-bs-dismiss="modal"
//                                             aria-label="Close"
//                                         />
//                                     </div>
//                                     <div className="modal-body">
//                                         <div className="row">
//                                             {Pms?.PMS === "Opera" && (
//                                                 <div className="col-md-6">
//                                                     <div className="mb-3">
//                                                         <label className="form-label">Rate code</label>
//                                                         <select className="form-control form-select" value={selectedRate}
//                                                             onChange={(e) => setSelectedRate(e.target.value)} >
//                                                             <option>Select code</option>
//                                                             {ratecode.map((item) => (
//                                                                 <option key={item.RateCodeID} value={item.RateCodeID}>
//                                                                     {item.Name}
//                                                                 </option>
//                                                             ))}
//                                                         </select>
//                                                     </div>
//                                                 </div>
//                                             )}
//                                             <div className="col-md-6">
//                                                 <div className="mb-3">
//                                                     <label className="form-label">Meal Plan</label>
//                                                     <select className="form-control form-select" value={selectedMealPlan}
//                                                         onChange={(e) => setSelectedMealPlan(e.target.value)}>
//                                                         <option>Select Plan</option>
//                                                         {mealplan.map((item) => (
//                                                             <option key={item.MealPlanID} value={item.MealPlanID}>
//                                                                 {item.Name}
//                                                             </option>
//                                                         ))}
//                                                     </select>
//                                                 </div>
//                                             </div>
//                                             <div className="col-md-12">
//                                                 <div className="mb-3">
//                                                     <label className="form-label">Room Name</label>
//                                                     {/* <select className="form-control form-select" value={selectedRoom}
//                                                         onChange={(e) => setSelectedRoom(e.target.value)}>
//                                                         <option>Select Room</option>
//                                                         {rooms.map((room) => (
//                                                             <option key={room.RoomID} value={room.RoomID}>
//                                                                 {room.RoomName}
//                                                             </option>
//                                                         ))}
//                                                     </select> */}

//                                                     <Select
//                                                         isMulti
//                                                         className="basic-multi-select"
//                                                         classNamePrefix="select"
//                                                         name="rooms"
//                                                         options={rooms.map(room => ({
//                                                             value: room.RoomID,
//                                                             label: room.RoomName
//                                                         }))}

//                                                         value={rooms
//                                                             .filter(room => selectedRooms.includes(room.RoomID))
//                                                             .map(room => ({
//                                                                 value: room.RoomID,
//                                                                 label: room.RoomName
//                                                             }))
//                                                         }

//                                                         onChange={(selected) => {
//                                                             setSelectedRooms(selected ? selected.map(s => s.value) : []);
//                                                         }}
//                                                     />
//                                                 </div>
//                                             </div>



//                                             <div className="col-sm-2">
//                                                 <div className="mb-3">
//                                                     <label className="form-label">Base Rate</label>
//                                                     <input type="number" className="form-control" value={baseRate}
//                                                         min={0}
//                                                         onChange={(e) => setBaseRate(e.target.value)} />
//                                                 </div>
//                                             </div>
//                                             <div className="col-sm-2">
//                                                 <div className="mb-3">
//                                                     <label className="form-label">Double rate</label>
//                                                     <input className="form-control" type="number" min={0} value={doubleRate} onChange={(e) => setDoubleRate(e.target.value)} />
//                                                 </div>
//                                             </div>
//                                             <div className="col-sm-2">
//                                                 <div className="mb-3">
//                                                     <label className="form-label">Triple rate</label>
//                                                     <input className="form-control" type="number" min={0} value={tripleRate} onChange={(e) => setTripleRate(e.target.value)} />
//                                                 </div>
//                                             </div>
//                                             <div className="col-sm-2">
//                                                 <div className="mb-3">
//                                                     <label className="form-label">Extra bed</label>
//                                                     <input className="form-control" type="number" min={0} value={extraBed} onChange={(e) => setExtraBed(e.target.value)} />
//                                                 </div>
//                                             </div>
//                                             <div className="col-sm-2">
//                                                 <div className="mb-3">
//                                                     <label className="form-label">Extra Adult rate</label>
//                                                     <input type="number" className="form-control" value={extraAdultRate}
//                                                         min={0}
//                                                         onChange={(e) => setExtraAdultRate(e.target.value)} />
//                                                 </div>
//                                             </div>
//                                             <div className="col-sm-2">
//                                                 <div className="mb-3">
//                                                     <label className="form-label">Extra Child Rate</label>
//                                                     <input type="number" className="form-control" value={extraChildRate}
//                                                         min={0}
//                                                         onChange={(e) => setExtraChildRate(e.target.value)} />
//                                                 </div>
//                                             </div>
//                                             <div className="col-sm-6">
//                                                 <div className="mb-3">
//                                                     <label className="form-label">Efactive From</label>
//                                                     <input type="date" className="form-control" value={effectiveFrom}
//                                                         onChange={(e) => setEffectiveFrom(e.target.value)} />
//                                                 </div>
//                                             </div>
//                                             <div className="col-sm-6">
//                                                 <div className="mb-3">
//                                                     <label className="form-label">Effactive To</label>
//                                                     <input type="date" className="form-control" value={effectiveTo}
//                                                         onChange={(e) => setEffectiveTo(e.target.value)} />
//                                                 </div>
//                                             </div>
//                                             <div className="col-sm-4">
//                                                 <div className="mb-3 d-flex">
//                                                     <label className="form-label me-2">Active</label>
//                                                     <input type="checkbox" style={{ marginTop: "-7px" }} checked={isActive}
//                                                         onChange={(e) => setIsActive(e.target.checked)} />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className="modal-footer">
//                                         <button className="btn btn-primary btn-sm" onClick={handleSubmit}>Submit</button>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         {/* /Modal */}
//                     </>

//                 </div>

//             </div >
//         </>
//     )
// }


import { useEffect, useState } from "react";
import Hearder from "../../commun/Hearder";
import SideBar from "../../commun/SideBar";
import Select from "react-select";
import swal from "sweetalert";
import { PropertyMAppingList, PropertyMealplan, PropertyRateCode, roomlistdetail, PropertySaveMapping, PropertyMappingDelete, getBasicPropertydetails } from "../../../Services/Service";
import { NavLink } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";

export const RateInventory = () => {
    const [loading, setLoading] = useState(false);
    const [ratecode, setRatecode] = useState([]);
    const [mealplan, setMealplan] = useState([]);
    const [rooms, setRooms] = useState([]);
    const [selectedRate, setSelectedRate] = useState("");
    const [selectedMealPlan, setSelectedMealPlan] = useState("");
    const [selectedRoom, setSelectedRoom] = useState("");
    const [defaultRateCodeId, setDefaultRateCodeId] = useState(0);
    const [baseRate, setBaseRate] = useState(0);
    const [doubleRate, setDoubleRate] = useState(0);
    const [tripleRate, setTripleRate] = useState(0);
    const [extraBed, setExtraBed] = useState(0);
    const [extraAdultRate, setExtraAdultRate] = useState(0);
    const [extraChildRate, setExtraChildRate] = useState(0);
    const [effectiveFrom, setEffectiveFrom] = useState("");
    const [effectiveTo, setEffectiveTo] = useState("");
    const [isActive, setIsActive] = useState(true);
    const [editId, setEditId] = useState(0);
    const [Pms, setPMS] = useState();

    const [filteredList, setFilteredList] = useState([]);
    const [selectedRooms, setSelectedRooms] = useState([]);

    // tracks whether the user has applied a filter yet.
    // Table stays empty (with a custom message) until this becomes true.
    const [isFiltered, setIsFiltered] = useState(false);

    // Property Rate Code 
    useEffect(() => {
        const FetchRatecode = async () => {
            try {
                const result = await PropertyRateCode();

                if (Array.isArray(result) && result.length > 0) {
                    setRatecode(result);

                    // First JSON ki RateCodeID
                    setDefaultRateCodeId(result[0].RateCodeID);
                } else {
                    setRatecode([]);
                    setDefaultRateCodeId(0);
                }
            } catch (error) {
                console.log("error get rate code", error);
                setDefaultRateCodeId(0);
            }
        };

        FetchRatecode();
    }, []);


    // meal paln detail
    useEffect(() => {
        const FetchMealplan = async () => {
            try {
                const result = await PropertyMealplan();
                if (Array.isArray(result)) setMealplan(result);
            }
            catch (error) {
                console.log("error get meal plan", error);
            }
        }
        FetchMealplan();
    }, []);

    // room detail 
    // Room detail
    useEffect(() => {
        const fetchRoomData = async () => {
            try {
                const data = await roomlistdetail();

                if (Array.isArray(data) && data.length > 0) {
                    setRooms(data);

                    // Default first room select hoga
                    setSelectedRoom(data[0].RoomID);
                } else {
                    setRooms([]);
                    setSelectedRoom("");
                }
            } catch (error) {
                console.error("Room data fetch error:", error);
                setRooms([]);
                setSelectedRoom("");
            }
        };

        fetchRoomData();
    }, []);

    // Open modal for edit
    const handleEdit = (item) => {
        setEditId(item.RateCodeMealPlanID);
        setSelectedRate(item.RateCodeID);
        setSelectedMealPlan(item.MealPlanID);
        setSelectedRoom(item.RoomTypeID);
        setBaseRate(item.BaseRate);
        setDoubleRate(item.DoubleRate);
        setTripleRate(item.TripleRate);
        setExtraBed(item.ExtraBed);
        setExtraAdultRate(item.ExtraAdultRate);
        setExtraChildRate(item.ExtraChildRate);
        setEffectiveFrom(item.EffectiveFrom.split("T")[0]);
        setEffectiveTo(item.EffectiveTo.split("T")[0]);
        setIsActive(item.IsActive === 1);
    };

    // ─── Refresh list using currently applied filters (backend call) ───
    const refreshFilteredList = async () => {
        if (!isFiltered) return; // filter apply nahi hai to refresh ki zaroorat nahi
        try {
            const result = await PropertyMAppingList(
                selectedRate || 0,
                selectedRoom,
                selectedMealPlan || 0,
                effectiveFrom,
                effectiveTo
            );
            setFilteredList(Array.isArray(result) ? result : []);
        } catch (error) {
            console.log("error refreshing mapping list", error);
        }
    };

    // Submit handler
    const handleSubmit = async () => {
        if (!selectedMealPlan || !selectedRoom) {
            swal("Error", "Please select Rate, Meal Plan and Room", "error");
            return;
        }
        try {
            setLoading(true);

            await PropertySaveMapping(
                editId,
                selectedRate || 0,
                selectedMealPlan,
                selectedRoom,
                baseRate,
                doubleRate,
                tripleRate,
                extraBed,
                extraAdultRate,
                extraChildRate,
                effectiveFrom,
                effectiveTo,
                isActive ? 1 : 0
            );

            // refresh table (agar filter applied hai to same filters ke sath)
            await refreshFilteredList();

            // show success alert
            swal("Data Saved successfully", {
                icon: "success",
                buttons: {
                    confirm: {
                        text: "OK",
                        className: "btn btn-success",
                    },
                },
            }).then(() => {
                // close modal
                const modal = window.bootstrap.Modal.getInstance(
                    document.getElementById("example-modal-lg")
                );
                if (modal) modal.hide();

                // reset form fields
                setSelectedRate("");
                setSelectedMealPlan("");
                setSelectedRoom("");
                setBaseRate("");
                setDoubleRate("");
                setTripleRate("");
                setExtraBed("");
                setExtraAdultRate("");
                setExtraChildRate("");
                setEffectiveFrom("");
                setEffectiveTo("");
                setIsActive(true);
                setEditId(0);
            });

        } catch (error) {
            console.log("Error saving mapping", error);
            swal("Failed to save data!", { icon: "error" });
        } finally {
            setLoading(false);
        }
    };


    const handleDelete = async (RateCodeMealPlanID) => {
        setLoading(true);
        try {
            const confirm = await swal({
                title: "Are you sure?",
                icon: "warning",
                buttons: {
                    cancel: "Cancel",
                    confirm: {
                        text: "Delete",
                        value: true,
                        visible: true,
                        className: "btn-danger",
                        closeModal: true,
                    },
                },
                dangerMode: true,
            });

            if (confirm) {
                await PropertyMappingDelete(RateCodeMealPlanID);

                // state update without refetch
                setFilteredList((prev) =>
                    prev.filter((item) => item.RateCodeMealPlanID !== RateCodeMealPlanID)
                );

                swal("Mapping deleted successfully!", {
                    icon: "success",
                });
            }
        } catch (error) {
            console.log("error deleting mapping", error);
            swal("Failed to delete mapping!", { icon: "error" });
        } finally {
            setLoading(false);
        }
    };


    const formatOptions = (list, labelKey, valueKey) => {
        return list.map((item) => ({
            label: item[labelKey],
            value: item[valueKey],
        }));
    };

    // Filter handler (ab API se hoga)
    const handleFilter = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const result = await PropertyMAppingList(
                selectedRate || 0,      // rateCodeId
                selectedRoom,      // RoomTypeID
                selectedMealPlan || 0,  // MealPlanID
                effectiveFrom,    // EffectiveFrom
                effectiveTo        // EffectiveTo
            );
            setFilteredList(Array.isArray(result) ? result : []);
            setIsFiltered(true);
        } catch (error) {
            console.log("error fetching filtered mapping list", error);
            setFilteredList([]);
            setIsFiltered(true);
        } finally {
            setLoading(false);
        }
    };

    // Clear handler
    const handleClear = () => {
        setSelectedRate("");
        setSelectedRoom("");
        setSelectedMealPlan("");
        setEffectiveFrom("");
        setEffectiveTo("");
        setFilteredList([]);
        setIsFiltered(false); // back to "No rate code List Found" state
    };

    useEffect(() => {
        const FetchPMS = async () => {
            try {
                const result = await getBasicPropertydetails();
                // console.log("pms result", result);
                if (result && result.length > 0) {
                    setPMS(result[0]);
                }
            }
            catch (error) {
                console.log("error fetch Pms in get api", error);
            }
        }
        FetchPMS();
    }, [])

    return (

        <>
            <style>{`
           .form-control{
            border-width: 1px !important;
            border-color: hsl(0, 0%, 80%);
           }
        `}</style>
            {loading && (
                <FullScreenLoader />
            )}
            <div className="wrapper">
                <SideBar />
                <div className="main-panel">
                    <Hearder />
                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-md-12">

                                    <div className="card">
                                        <div className="card-body">
                                            <form className="mb-0" onSubmit={handleFilter}>
                                                <div className="row">

                                                    <div className="col-sm-2">
                                                        <div className="mb-3">
                                                            <label className="form-label"> Room Name</label>

                                                            <Select
                                                                options={formatOptions(rooms, "RoomName", "RoomID")}
                                                                value={
                                                                    selectedRoom
                                                                        ? {
                                                                            label:
                                                                                rooms.find(
                                                                                    (room) =>
                                                                                        String(room.RoomID) === String(selectedRoom)
                                                                                )?.RoomName || "",
                                                                            value: selectedRoom,
                                                                        }
                                                                        : null
                                                                }
                                                                onChange={(option) =>
                                                                    setSelectedRoom(option ? option.value : "")
                                                                }
                                                                placeholder="Select room"
                                                                isClearable
                                                            />
                                                        </div>
                                                    </div>
                                                    {Pms?.PMS === "Opera" && (
                                                        <div className="col-sm-2">
                                                            <div className="mb-3">
                                                                <label className="form-label"> Rate Code</label>

                                                                <Select
                                                                    options={formatOptions(ratecode, "Name", "RateCodeID")}
                                                                    value={
                                                                        selectedRate
                                                                            ? {
                                                                                label:
                                                                                    ratecode.find((r) => r.RateCodeID === selectedRate)?.Name ||
                                                                                    "",
                                                                                value: selectedRate,
                                                                            }
                                                                            : null
                                                                    }
                                                                    onChange={(e) => setSelectedRate(e ? e.value : "")}
                                                                    placeholder="Select code"
                                                                    isClearable

                                                                />
                                                            </div>
                                                        </div>
                                                    )}


                                                    <div className="col-sm-2">
                                                        <div className="mb-3">
                                                            <label className="form-label"> Meal Plan</label>

                                                            <Select
                                                                options={formatOptions(mealplan, "Name", "MealPlanID")}
                                                                value={
                                                                    selectedMealPlan
                                                                        ? {
                                                                            label:
                                                                                mealplan.find((m) => m.MealPlanID === selectedMealPlan)
                                                                                    ?.Name || "",
                                                                            value: selectedMealPlan,
                                                                        }
                                                                        : null
                                                                }
                                                                onChange={(e) => setSelectedMealPlan(e ? e.value : "")}
                                                                placeholder="Select plan"
                                                                isClearable
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-2">
                                                        <div className="mb-3">
                                                            <label className="form-label"> From</label>
                                                            <input type="date" className="form-control" value={effectiveFrom}
                                                                onChange={(e) => setEffectiveFrom(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-2">
                                                        <div className="mb-3">
                                                            <label className="form-label"> To</label>
                                                            <input type="date" className="form-control" value={effectiveTo}
                                                                onChange={(e) => setEffectiveTo(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-2">
                                                        <div style={{ marginTop: "27px" }}>
                                                            <Button type="submit" label="Filter" size="small" className="btn btn-primary me-2" />
                                                            <Button type="button" label="Clear" size="small" severity="danger" onClick={handleClear} className="btn btn-danger" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">

                                    <div className="card">
                                        <div className="card-header">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <h4 className="card-title mb-0">Rate Inventory List</h4>
                                                <NavLink to="/Property/AddRateInventory" className="btn btn-sm btn-primary">Add</NavLink>
                                            </div>
                                        </div>
                                        <div className="card-body p-0">
                                            <div className="table-responsive">

                                                <DataTable
                                                    value={isFiltered ? filteredList : []}
                                                    dataKey="RateCodeMealPlanID"
                                                    paginator
                                                    rows={10}
                                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
                                                    stripedRows
                                                    removableSort
                                                    responsiveLayout="scroll"
                                                    emptyMessage={isFiltered ? "No records found" : "No rate code List Found"}
                                                >
                                                    {Pms?.PMS === "Opera" && (
                                                        <Column field="RateCodeName" header="Rate Code" sortable />
                                                    )}
                                                    <Column field="RoomName" header="Room Name" sortable style={{ minWidth: "220px" }} />
                                                    <Column field="MealPlanName" header="Meal Plan" sortable />
                                                    <Column field="BaseRate" header="Base Rate" sortable body={(row) => `₹ ${row.BaseRate ?? 0}`} />
                                                    <Column field="EffectiveFrom" header="From" sortable body={(row) => row.EffectiveFrom ? new Date(row.EffectiveFrom).toLocaleDateString("en-GB") : "-"} />
                                                    <Column field="EffectiveTo" header="To" sortable body={(row) => row.EffectiveTo ? new Date(row.EffectiveTo).toLocaleDateString("en-GB") : "-"} />
                                                    <Column
                                                        field="IsActive"
                                                        header="Status"
                                                        body={(row) => (
                                                            <span className={`badge ${row.IsActive ? "bg-success" : "bg-danger"}`}>
                                                                {row.IsActive ? "Active" : "Inactive"}
                                                            </span>
                                                        )}
                                                    />
                                                    <Column
                                                        header="Action"
                                                        body={(row) => (
                                                            <div className="d-flex align-items-center gap-2">
                                                                <Button
                                                                    type="button"
                                                                    icon="pi pi-pencil"
                                                                    text
                                                                    size="small"
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#example-modal-lg"
                                                                    aria-label={`Edit ${row.RoomName}`}
                                                                    onClick={() => handleEdit(row)}
                                                                />
                                                                <Button
                                                                    type="button"
                                                                    icon="pi pi-trash"
                                                                    text
                                                                    severity="danger"
                                                                    size="small"
                                                                    aria-label={`Delete ${row.RoomName}`}
                                                                    onClick={() => handleDelete(row.RateCodeMealPlanID)}
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                </DataTable>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <>
                        {/*  Modal */}
                        <div
                            className="modal fade"
                            id="example-modal-lg"
                            tabIndex={-1}
                            role="dialog"
                            aria-labelledby="myLargeModalLabel"
                            aria-hidden="true"
                        >
                            <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="myLargeModalLabel">
                                            {editId === 0 ? "Add Rates" : "Edit Rates"}
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                        />
                                    </div>
                                    <div className="modal-body">
                                        <div className="row">
                                            {Pms?.PMS === "Opera" && (
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">Rate code</label>
                                                        <select className="form-control form-select" value={selectedRate}
                                                            onChange={(e) => setSelectedRate(e.target.value)} >
                                                            <option>Select code</option>
                                                            {ratecode.map((item) => (
                                                                <option key={item.RateCodeID} value={item.RateCodeID}>
                                                                    {item.Name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            )}
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Meal Plan</label>
                                                    <select className="form-control form-select" value={selectedMealPlan}
                                                        onChange={(e) => setSelectedMealPlan(e.target.value)}>
                                                        <option>Select Plan</option>
                                                        {mealplan.map((item) => (
                                                            <option key={item.MealPlanID} value={item.MealPlanID}>
                                                                {item.Name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label className="form-label">Room Name</label>
                                                    <Select
                                                        isMulti
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        name="rooms"
                                                        options={rooms.map(room => ({
                                                            value: room.RoomID,
                                                            label: room.RoomName
                                                        }))}

                                                        value={rooms
                                                            .filter(room => selectedRooms.includes(room.RoomID))
                                                            .map(room => ({
                                                                value: room.RoomID,
                                                                label: room.RoomName
                                                            }))
                                                        }

                                                        onChange={(selected) => {
                                                            setSelectedRooms(selected ? selected.map(s => s.value) : []);
                                                        }}
                                                    />
                                                </div>
                                            </div>



                                            <div className="col-sm-2">
                                                <div className="mb-3">
                                                    <label className="form-label">Base Rate</label>
                                                    <input type="number" className="form-control" value={baseRate}
                                                        min={0}
                                                        onChange={(e) => setBaseRate(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="mb-3">
                                                    <label className="form-label">Double rate</label>
                                                    <input className="form-control" type="number" min={0} value={doubleRate} onChange={(e) => setDoubleRate(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="mb-3">
                                                    <label className="form-label">Triple rate</label>
                                                    <input className="form-control" type="number" min={0} value={tripleRate} onChange={(e) => setTripleRate(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="mb-3">
                                                    <label className="form-label">Extra bed</label>
                                                    <input className="form-control" type="number" min={0} value={extraBed} onChange={(e) => setExtraBed(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="mb-3">
                                                    <label className="form-label">Extra Adult rate</label>
                                                    <input type="number" className="form-control" value={extraAdultRate}
                                                        min={0}
                                                        onChange={(e) => setExtraAdultRate(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-sm-2">
                                                <div className="mb-3">
                                                    <label className="form-label">Extra Child Rate</label>
                                                    <input type="number" className="form-control" value={extraChildRate}
                                                        min={0}
                                                        onChange={(e) => setExtraChildRate(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Efactive From</label>
                                                    <input type="date" className="form-control" value={effectiveFrom}
                                                        onChange={(e) => setEffectiveFrom(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="mb-3">
                                                    <label className="form-label">Effactive To</label>
                                                    <input type="date" className="form-control" value={effectiveTo}
                                                        onChange={(e) => setEffectiveTo(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="mb-3 d-flex">
                                                    <label className="form-label me-2">Active</label>
                                                    <input type="checkbox" style={{ marginTop: "-7px" }} checked={isActive}
                                                        onChange={(e) => setIsActive(e.target.checked)} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button className="btn btn-primary btn-sm" onClick={handleSubmit}>Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* /Modal */}
                    </>
                </div>
            </div >
        </>
    )
}
